var publicPath = __webpack_public_path__;
                    var symbolUrl = 'gfx/sprite.svg#icon-Hamburger';
                    var viewUrl = 'gfx/sprite.svg#view-icon-Hamburger';

                    

                    module.exports = {
                        symbol: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 28 22',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };